import { Grid, theme } from 'antd';

const { useBreakpoint } = Grid;

function matchesMobileWidth(maxWidth: number): boolean {
  if (typeof window === 'undefined' || !window.matchMedia) {
    return false;
  }

  return window.matchMedia(`(max-width: ${maxWidth}px)`).matches;
}

/**
 * Whether the shell is in its mobile layout — below antd's `md`, where the side
 * menu moves into a drawer and the header collapses its search.
 *
 * The single definition of "mobile" for the shell's JS. Its CSS counterpart is
 * `touchTargetStyles`, which keys off `theme.antd.screenSMMax` — the same
 * breakpoint from the other side.
 *
 * `md` is the only breakpoint that can answer this. antd's breakpoint map is
 * cumulative min-widths, so `sm` is true on a 1440px desktop as well as on a
 * 600px phone; only `!md` means "narrower than 768".
 */
export function useIsMobile(): boolean {
  const screens = useBreakpoint();
  const { token } = theme.useToken();

  // antd's observer subscribes in a layout effect, so the first render gets an
  // empty map at every viewport width. Reading that as `!md` claims mobile on
  // desktop, and callers that capture the value on first render keep the wrong
  // one — `sideMenuCollapsed` is persisted from exactly such a capture. Answer
  // that one render from the media query instead of guessing.
  if (screens.md === undefined) {
    return matchesMobileWidth(token.screenSMMax);
  }

  return !screens.md;
}
